import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class OutsideClickHandler extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.onClickOutside(event);
    }
  }

  render() {
    const wrapperClass = classnames('outside-click-handler', {
      [this.props.extraClass]: this.props.extraClass,
    });
    return <div className={wrapperClass}  ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}

OutsideClickHandler.propTypes = {
  children: PropTypes.node,
  onClickOutside: PropTypes.func,
  extraClass: '',
};

OutsideClickHandler.defaultProps = {
  onClickOutside: () => { },
};
